import { GlobalContext } from "./Global.context";

export function GlobalProvider({ children, value }) {
  return (
    <GlobalContext.Provider value={value}>{children}</GlobalContext.Provider>
  );
}
